module.exports = __webpack_public_path__ + "static/media/motorcycle.c37edbec.jpg";